/*
  Expanded Workflow Container Styles

  Styled components specifically for the expanded workflow container node.
  Separates the complex layout styling from the component logic.
*/

import styled from 'styled-components';

/**
 * Main container that fills the parent and allows pointer events to pass through
 */
export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: none;
`;

/**
 * Background layer with border and shadow
 * Separate element to avoid interfering with edge rendering
 */
export const BackgroundLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: 1px solid var(--cl-gray-200);
  border-radius: var(--cl-radius-2);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  pointer-events: none;
  opacity: 0.95;
`;

/**
 * Header section displaying workflow info and controls
 */
export const Header = styled.div<{ height: number }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${({ height }) => height}px;
  padding: var(--cl-space-3) var(--cl-space-4);
  background-color: var(--cl-gray-000);
  border-top-left-radius: var(--cl-radius-2);
  border-top-right-radius: var(--cl-radius-2);
  border-bottom: 1px solid var(--cl-gray-200);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  pointer-events: auto;
  z-index: 10;
`;

/**
 * Workflow info section (name + version badge)
 */
export const WorkflowInfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/**
 * Content area providing visual padding for child nodes
 */
export const ContentArea = styled.div<{ topOffset: number; padding: number }>`
  position: absolute;
  top: ${({ topOffset }) => topOffset}px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: ${({ padding }) => padding}px;
  pointer-events: none;
`;

/**
 * Visible handle styling for workflow container
 * These handles are visible unlike the standard hidden ones
 */
export const handleStyle = {
  width: 8,
  height: 8,
  backgroundColor: '#3b82f6',
  border: '2px solid #ffffff',
  borderRadius: '50%',
  zIndex: 10,
};

export const inputHandleStyle = {
  ...handleStyle,
  left: -4,
  top: '50%',
};

export const outputHandleStyle = {
  ...handleStyle,
  right: -4,
  top: '50%',
};

